import type { Sentiment } from '@hotjar/feedback/domain/IncomingFeedback/FeedbackResultsDto';
import { roundNumber } from '@hotjar/insights-common/lib/number';

// Same as /packages/legacy/src/webapp-ng/src/feedback/js/controllers/feedback-responses-ctrl.js#L476
export const getAverageScore = (sentiment: Sentiment): number => {
  const { responsesCount, sum } = Object.values(sentiment).reduce(
    (previousValue, currentValue, currentIndex) => {
      return {
        responsesCount: previousValue.responsesCount + currentValue,
        sum: previousValue.sum + currentValue * (currentIndex + 1),
      };
    },
    { responsesCount: 0, sum: 0 },
  );

  return roundNumber(sum / responsesCount);
};
